import XLSX from "xlsx-js-style";

export const generateAuditExcel = (auditRows, headerInfo, auditType = "Payroll") => {
    if (!auditRows || auditRows.length === 0 || !headerInfo) {
        alert("No data available to export.");
        return;
    }

    const isWages = headerInfo?.itemType === "Wages";
    const isEmployerTaxes = headerInfo?.itemType === "EmployerTaxes";

    const mainTableHeaders = auditType === "Employee" 
        ? [
            "Employee Name",
            "Phone",
            "Email",
            "SSN",
            "Check To Be Printed As",
            "Pay Frequency",
            "Department",
            "Job Title",
            "Action",
            "Action Date",
            "Action By",
            "Status",
        ]
        : [
            "Item Type",
            "Item Name",
            ...(isWages ? ["Pay Type", "Wage Type"] : []),
            "Department",
            "Job Title",
            "Expense COA",
            ...(isEmployerTaxes ? ["Payable COA"] : []),
            "Action",
            "Action Date",
            "Action By",
            "Status",
        ];

    const flattenedRows = [];

    auditRows.forEach(audit => {
        const auditInfo = {
            "Action": audit.ActionName,
            "Action Date": audit.ActionDate,
            "Action By": audit.ActionByName,
            "Status": audit.IsActive,
        };

        if (auditType === "Employee") {
            const baseInfo = {
                "Employee Name": audit.EmployeeName || "",
                "Phone": audit.MobileNum || "",
                "Email": audit.EmailID || "",
                "SSN": audit.Ssn || "",
                "Check To Be Printed As": audit.CheckToBePrinted || "",
            };
            const details = Array.isArray(audit.PayrollDetails) ? audit.PayrollDetails.filter(p => p?.Department || p?.JobTitle) : [];
            const uniquePayroll = [...new Map(details.map(item => [`${item.Department}-${item.JobTitle}`, item])).values()];
            if (uniquePayroll.length === 0) {
                flattenedRows.push({ ...baseInfo, "Pay Frequency": "", "Department": "", "Job Title": "", ...auditInfo });
            } else {
                uniquePayroll.forEach(p => {
                    flattenedRows.push({ ...baseInfo, "Pay Frequency": p.Frequency || "", "Department": p.Department || "", "Job Title": p.JobTitle || "", ...auditInfo });
                });
            }
        } else {
            const details = audit.PayrollAuditDeptJobDetails || [];
            const baseInfo = {
                "Item Type": headerInfo?.itemType || "",
                "Item Name": audit.ItemName || "",
                ...(isWages && { "Pay Type": audit.PayType || "" }),
                ...(isWages && { "Wage Type": audit.WageType || "" }),
            };
            if (details.length === 0) {
                flattenedRows.push({
                    ...baseInfo,
                    Department: "",
                    "Job Title": "",
                    "Expense COA": "",
                    ...(isEmployerTaxes && { "Payable COA": "" }),
                    ...auditInfo
                });
            } else {
                details.forEach(row => {
                    flattenedRows.push({
                        ...baseInfo,
                        Department: row.Department || "",
                        "Job Title": row.JobTitle || "",
                        "Expense COA": row.AccountName || "",
                        ...(isEmployerTaxes && { "Payable COA": row.LiabilityAccName || "" }),
                        ...auditInfo
                    });
                });
            }
        }
    });

    const worksheet = XLSX.utils.json_to_sheet(flattenedRows, {
        header: mainTableHeaders
    });

    const range = XLSX.utils.decode_range(worksheet["!ref"]);

    /* AUTO COLUMN WIDTH */

    worksheet["!cols"] = mainTableHeaders.map(header => {
        const maxLength = Math.max(
            header.length,
            ...flattenedRows.map(row =>
                row[header] ? row[header].toString().length : 0
            )
        );

        return { wch: Math.min(maxLength + 3, 40) };
    });

    /* HEADER STYLE (MATCH UI GRID) */

    for (let col = range.s.c; col <= range.e.c; col++) {
        const cellAddress = XLSX.utils.encode_cell({ r: 0, c: col });

        if (worksheet[cellAddress]) {
            worksheet[cellAddress].s = {
                font: {
                    name: "Poppins",
                    bold: true,
                    sz: 9,
                    color: { rgb: "000000" }
                },
                fill: {
                    fgColor: { rgb: "F5F5F5" }
                },
                alignment: {
                    horizontal: "center",
                    vertical: "center"
                },
               
            };
        }
    }

    /* BODY STYLE */

    for (let row = 1; row <= range.e.r; row++) {
        for (let col = range.s.c; col <= range.e.c; col++) {
            const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });

            if (worksheet[cellAddress]) {
                worksheet[cellAddress].s = {
                    font: {
                        name: "Poppins",
                        sz: 9
                    },
                    alignment: {
                        vertical: "center"
                    },
                    
                };
            }
        }
    }

    /* FREEZE HEADER */

    worksheet["!freeze"] = {
        xSplit: 0,
        ySplit: 1
    };

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "AuditLog");

    XLSX.writeFile(workbook, `${auditType}AuditLog.xlsx`);
};